import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomeScreen from './pages/HomeScreen'; // Re-imported HomeScreen if needed or keep using EventDetail as primary
import EventDetailScreen from './pages/EventDetailScreen';
import LoginScreen from './pages/LoginScreen';
import RegisterScreen from './pages/RegisterScreen';
import SeatSelectionScreen from './pages/SeatSelectionScreen';
import PaymentScreen from './pages/PaymentScreen';
import PaymentReturnHandler from './pages/PaymentReturnHandler';
import SuccessScreen from './pages/SuccessScreen';
import TicketScreen from './pages/TicketScreen';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-cream font-outfit text-secondary selection:bg-primary/20 selection:text-secondary">
        <Routes>
          {/* Main Entry Point */}
          <Route path="/" element={<HomeScreen />} />
          <Route path="/event/:id" element={<EventDetailScreen />} />

          <Route path="/login" element={<LoginScreen />} />
          <Route path="/register" element={<RegisterScreen />} />
          <Route path="/book/:id" element={<SeatSelectionScreen />} />
          <Route path="/payment" element={<PaymentScreen />} />
          <Route path="/payment-returned" element={<PaymentReturnHandler />} />
          <Route path="/success" element={<SuccessScreen />} />
          <Route path="/ticket" element={<TicketScreen />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
